const EmailCardSkeleton = () => {
  return (
    <div className="skeleton-email-card">
      <div className="skeleton-email-card-main">
        <div className="skeleton-email-card-selectors">
          <div className="skeleton-checkbox" />
          <div className="skeleton-star" />
        </div>
        <div className="skeleton-email-card-content">
          <div className="skeleton-email-card-header">
            <div className="skeleton-sender" />
            <div className="skeleton-date" />
          </div>
          <div className="skeleton-email-card-body">
            <div className="skeleton-subject" />
            <div className="skeleton-preview" />
            <div className="skeleton-preview skeleton-preview--short" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailCardSkeleton;
